// passwordRules.js
// WEST-599: the password rules as one place to read them from. Mirrors Tax.Helpers.PasswordHelper
// (10+ chars, a number, an uppercase letter, a symbol, no spaces) and the checklist UserNewForm /
// UserForm render. Those forms keep their own copy for now; new screens use this.
import React from 'react';

export const evaluatePassword = (password) => {
  const value = password || '';
  return {
    length: value.length >= 10,
    number: /\d/.test(value),
    uppercase: /[A-Z]/.test(value),
    symbol: /[\W_]/.test(value),
    noSpaces: value.length > 0 && !/\s/.test(value),
  };
};

export const isPasswordValid = (validation) => Object.values(validation).every(Boolean);

export const PasswordRulesList = ({ validation }) => (
  <div className="password-validation">
    <ul>
      <li className={validation.length ? 'valid' : 'invalid'}>At least 10 characters</li>
      <li className={validation.number ? 'valid' : 'invalid'}>At least 1 number</li>
      <li className={validation.uppercase ? 'valid' : 'invalid'}>At least 1 uppercase letter</li>
      <li className={validation.symbol ? 'valid' : 'invalid'}>At least 1 symbol (!@#$%^&amp;*)</li>
      <li className={validation.noSpaces ? 'valid' : 'invalid'}>No spaces</li>
    </ul>
  </div>
);
